import { useQuery } from '@tanstack/react-query';

import requestQueries from '@facilities/utils/requestQueryFactory';

const useFetchTasks = (facilityId: string) => useQuery(requestQueries.tasks(facilityId));

export default useFetchTasks;
